import InfoscreenConfig from '@/components/devices/Infoscreen/config';

export default class AudioNotifier {
  constructor(audioFiles, AudioPlayer) {
    this.audioPlayer = new AudioPlayer({ cancelAudioCallTicketTimeout: InfoscreenConfig.CANCEL_AUDIO_CALL_TICKET_TIMEOUT });
    this.AUDIO_FILES = audioFiles;
  }

  getAudioByKey(audioKey) {
    const audioSequence = [];
    this.addAudioFileToSequence(audioSequence, audioKey);
    return audioSequence;
  }

  generateAudioByChars(str) {
    const audioSequence = [];
    for (const char of str) this.addAudioFileToSequence(audioSequence, char.toUpperCase());
    return audioSequence;
  }

  generateAudioByString(str) {
    const generateToAudio = (value) => {
      const numberValue = Number(value);

      if (Number.isInteger(numberValue)) {
        if (numberValue <= 999) {
          return this.generateAudioByNumber(numberValue);
        } else {
          return this.generateAudioByChars(value);
        }
      } else {
        return this.generateAudioByChars(value);
      }
    }

    const audio = [];
    let lastResult = '';

    for (let i = 0; i < str.length; i++) {
      const lastResultIsNumber = Number.isInteger(Number(lastResult));
      const currentCharIsNumber = Number.isInteger(Number(str[i]));

      if ((lastResultIsNumber && currentCharIsNumber) || (!lastResultIsNumber && !currentCharIsNumber)) {
        lastResult += str[i];
      } else {
        audio.push(...generateToAudio(lastResult));
        lastResult = str[i];
      }

      if (i === str.length - 1) {
        audio.push(...generateToAudio(lastResult));
      }
    }

    return audio;
  }

  generateAudioByNumber(number) {
    const audioSequence = [];
    const addAudioFileToSequence = this.addAudioFileToSequence.bind(this, audioSequence);

    if (number >= 100) {
      const hundreds = Math.floor(number / 100);
      addAudioFileToSequence(hundreds * 100);

      const remainder = number - hundreds * 100;
      if (remainder > 0) addAudioFileToSequence(remainder);
    } else {
      addAudioFileToSequence(number);
    }

    return audioSequence;
  }

  addAudioFileToSequence(audioSequence, audioKey) {
    if (!this.AUDIO_FILES[audioKey]) return;
    audioSequence.push(this.AUDIO_FILES[audioKey]);
  }

  playAudioSequence(audioSequence) {
    return this.audioPlayer.playAudioSequence(audioSequence);
  }
}
